import {LeaderboardsTabsType, LeaderboardUsersType} from "modules";
import Leaderboard from "./leaderboardContent/Leaderboard";
import React, {Fragment, useEffect, useRef} from "react";
import {useDispatch, useSelector} from "react-redux";
import {
	getFetchedLeaderboardPages,
	getIsLoadedLeaderboards,
	getLeaderboard,
} from "modules/selectors";
import {clearFetchedPagesLeaderboards, fetchLeaderboard} from "modules/actions/leaderboards";
import styled from "@emotion/styled";
import {useTranslation} from "react-i18next";
import {getFirstRound} from "modules/selectors/rounds";
import {defaultTo, max, min} from "lodash";

// const NoFriends = styled.div`
// 	display: flex;
// 	align-items: center;
// 	justify-content: center;
// 	width: 100%;
// 	height: 100%;
// 	font-weight: 400;
// 	font-size: 16px;
// 	line-height: 130%;
// 	flex-flow: column;
// 	min-height: 200px;
//
// 	span {
// 		text-align: center;
// 	}
// `;
//
// const InviteButton = styled.button`
// 	height: 40px;
// 	background: #142845;
// 	border-radius: 100px;
// 	font-weight: 700;
// 	font-size: 16px;
// 	color: #68a3f8;
// 	border: none;
// 	padding: 10px 30px;
// 	margin-top: 16px;
// `;

const LastUpdated = styled.div`
	background: #292f37;
	border-radius: 4px;
	font-weight: 400;
	padding: 8px 16px;
	font-size: 14px;
	position: relative;
	text-align: center;
	max-width: 90%;
	margin: 0 auto;
`;

interface IProps {
	leaderboardUsersType: LeaderboardUsersType;
	setCurrentPage: (pageNumber: number) => void;
	currentPage: number;
	leagueId?: number;
	selectedTab: LeaderboardsTabsType;
}

const LeaderboardContent: React.FC<IProps> = ({
	leaderboardUsersType,
	currentPage,
	leagueId,
	setCurrentPage,
	selectedTab,
}) => {
	const dispatch = useDispatch();
	const i18n = useTranslation();
	const haveToClear = useRef(false);
	const isPrevLeaderboard = useRef(false);
	const leaderboards = useSelector(getLeaderboard);
	const firstRound = useSelector(getFirstRound);
	const fetchedPages = useSelector(getFetchedLeaderboardPages);
	const firstPage = defaultTo(min(fetchedPages), 1);
	const lastPage = defaultTo(max(fetchedPages), 1);
	const isLoaded = useSelector(getIsLoadedLeaderboards);
	const season = new Date(firstRound?.date || "").getFullYear();

	useEffect(() => {
		haveToClear.current = true;
	}, [leaderboardUsersType, selectedTab, leagueId]);

	useEffect(() => {
		dispatch(
			fetchLeaderboard({
				season,
				page: currentPage,
				limit: 100,
				leagueId,
				haveToClear: haveToClear.current,
				isPrevLeaderboard: isPrevLeaderboard.current,
				usersType: leaderboardUsersType,
				ranksType: selectedTab,
			})
		);
		haveToClear.current = false;
	}, [dispatch, leagueId, season, selectedTab, currentPage, leaderboardUsersType]);

	const setPageFn = (nextPage: number) => {
		const lastUsedPage = nextPage > currentPage ? lastPage : firstPage;

		if (Math.abs(nextPage - lastUsedPage) > 1 || nextPage === 1) {
			haveToClear.current = true;
			dispatch(clearFetchedPagesLeaderboards());
		}

		isPrevLeaderboard.current = currentPage > nextPage;
		setCurrentPage(nextPage);
	};

	// const invite = () => {
	// 	try {
	// 		if (RallySSO.IS_NATIVE) {
	// 			RallySSO.nativeBridge?.inviteFriend();
	// 		}
	// 	} catch (e) {
	// 		dispatch(
	// 			showGlobalError({
	// 				code: 0,
	// 				message: `Invite error... ${(e as Error).message}`,
	// 			})
	// 		);
	// 	}
	// };

	return (
		<Fragment key={selectedTab}>
			{!leaderboards.user && isLoaded && !!leagueId && (
				<LastUpdated>
					{i18n.t(
						"leaderboards.table.no_user",
						"You will appear in the Group Standings when the game next calculates"
					)}
				</LastUpdated>
			)}
			{/*{leaderboardUsersType === LeaderboardUsersType.Friends &&*/}
			{/*!leaderboards.friendsParticipantsCount ? (*/}
			{/*	<NoFriends>*/}
			{/*		<span>*/}
			{/*			{i18n.t(*/}
			{/*				"leaderboard.table.no_friends",*/}
			{/*				"There aren’t any more scores to display. Invite some friends to play!"*/}
			{/*			)}*/}
			{/*		</span>*/}
			{/*		<Exist when={RallySSO.IS_NATIVE}>*/}
			{/*			<InviteButton onClick={invite}>*/}
			{/*				{i18n.t("leaderboard.table.invite_friends", "Invite friends!")}*/}
			{/*			</InviteButton>*/}
			{/*		</Exist>*/}
			{/*	</NoFriends>*/}
			{/*) : (*/}
			<Leaderboard
				leaderboards={leaderboards}
				currentPage={currentPage}
				setPage={setPageFn}
				firstPage={firstPage}
				lastPage={lastPage}
				selectedTab={selectedTab}
			/>
			{/*)}*/}
		</Fragment>
	);
};

export default LeaderboardContent;
